import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h6","key":"svg-0"}],["path",{"d":"M18 19v-14l-4 4","key":"svg-1"}]]

/**
 * IconExposureMinus1
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZXhwb3N1cmUtbWludXMtMSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMyAxMmg2IiAvPgogIDxwYXRoIGQ9Ik0xOCAxOXYtMTRsLTQgNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/exposure-minus-1
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconExposureMinus1 = createReactComponent('outline', 'exposure-minus-1', 'ExposureMinus1', __iconNode);

export default IconExposureMinus1;